<template>
      <div class="baseball-list list-month">
        <h4 class="a11y-hidden">프로야구 날짜 선택(연, 월 단위)</h4>
        <div class="month-container">
          <div class="txt-month">
            <span>{{currentDate.getFullYear()}}</span>
            <span>. </span>
            <span>{{currentDate.getMonth() + 1 | monthToString}}</span>
          </div>
          <button class="button-back" @click.prevent="changeDate(-1)">
            <img src="../../assets/images/kbo/all-arrow-prev.png" alt="이전">
          </button>
          <button class="button-next" @click.prevent="changeDate(1)">
            <img src="../../assets/images/kbo/all-arrow-next.png" alt="다음">
          </button>
          <span class="button-today">
            <button type="button" class="button-kbo button-kbo-filled" @click.prevent="goToDay()">오늘</button>
          </span>
        </div>
      </div>
</template>
<script>
import KboDate from '@/common/model/KboDate'

export default {
  componentName: 'YearMonthSelector',
  props: {
    currentDate: {
      type: Date
    },
    changeFn: {
      type: Function
    }
  },
  filters: {
    monthToString: function (month) {
      return Number(month) > 9 ? month : '0' + month
    }
  },
  methods: {
    changeDate (addMonth) {
      const month = this.currentDate.getMonth()
      const newDate = new KboDate(this.currentDate.getTime())
      newDate.setMonth(month + addMonth, 1)
      this.changeFn(newDate)
    },
    goToDay () {
      const toDay = new KboDate()
      this.changeFn(toDay)
    }
  }
}
</script>
